import React from 'react';
import styles from './AdminProjectDetailInfo.module.scss';
import BaseCard from '../../../../components/cards/BaseCard/BaseCard';
import { useTranslate } from 'react-translate.ts';
import IAdminProject from '../../../types/IAdminProject';
import useDate from '../../../../hooks/useDate';
import { Skeleton } from '@tcc-online/common-components';
import AdminProjectDetailInfoItem from '../AdminProjectDetailInfoItem/AdminProjectDetailInfoItem';
import AdminTable from '../../AdminTable/AdminTable';
import CountryFlag from '../../misc/CountryFlag/CountryFlag';

type AdminProjectDetailInfoProps = {
    project: IAdminProject;
    loading?: boolean;
};

const skeletonComponent = Array.from(new Array(5), (_, index: number) => (
    <Skeleton height={20} key={index} />
));

export default function AdminProjectDetailInfo(
    props: AdminProjectDetailInfoProps,
) {
    const { project, loading } = props;
    const translate = useTranslate();
    const created = useDate(project.createdDate, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const content = (
        <>
            <AdminProjectDetailInfoItem label={translate('Vytvoreno')}>
                {created}
            </AdminProjectDetailInfoItem>
            {!!project.primaryLanguage && (
                <AdminProjectDetailInfoItem label={translate('Jazyk')}>
                    <CountryFlag locale={project.primaryLanguage} />
                </AdminProjectDetailInfoItem>
            )}
            {!!project.locales?.length && (
                <AdminProjectDetailInfoItem label={translate('Jazyky')}>
                    {project.locales?.map((locale: string) => (
                        <CountryFlag locale={locale} />
                    ))}
                </AdminProjectDetailInfoItem>
            )}
            {!!project.position && (
                <AdminProjectDetailInfoItem label={translate('Pozice')}>
                    {project.position}
                </AdminProjectDetailInfoItem>
            )}
            {!!project.unit && (
                <AdminProjectDetailInfoItem label={translate('Jednotka')}>
                    {project.unit}
                </AdminProjectDetailInfoItem>
            )}
            {!!project.level && (
                <AdminProjectDetailInfoItem label={translate('Uroven')}>
                    {project.level}
                </AdminProjectDetailInfoItem>
            )}
        </>
    );

    return (
        <BaseCard className={styles.card}>
            {project.note && <p className={styles.note}>{project.note}</p>}
            <AdminTable>{!loading ? content : skeletonComponent}</AdminTable>
        </BaseCard>
    );
}
